import { MAP_TYPES } from '@deck.gl/carto';

const MIRAMARPRAPOSEDTOC_SOURCE_ID = 'miramarPraposedTOCSource';

const source = {
  id: MIRAMARPRAPOSEDTOC_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.TOC_Proposed_Parcel`,
};

export default source;
